import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { Institution } from 'shell/models/institution';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface ListInstitutionProps {
  disabled: boolean;
  value: string;
  required?: boolean;
  onChange: (event: SelectChangeEvent<string>) => void;
  label?: string;
  errorSelect?: boolean;
}

const ListInstitution = ({
  disabled,
  onChange,
  value,
  required,
  label = 'Ente',
  errorSelect = false,
}: ListInstitutionProps): React.ReactElement => {
  const {
    data,
    error,
    get: getListInstitutions,
  } = useHttpFetch<HttpResponseList<Institution>>(`${__MANAGEMENT_API_URL__}/enti`, {
    data: {
      payload: {
        list: [],
      },
    },
  });

  const institutions: Array<ItemVM> = useMemo(() => {
    if (!!error || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((institution) => ({
      id: institution.key?.codice,
      value: institution.nome,
    }));
  }, [data, error]);

  useEffect(() => {
    getListInstitutions();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={errorSelect} id={`institution-${label}`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`institution-${label}`}
        id="institution"
        aria-label={label}
        name="institution"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={errorSelect}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {institutions
          .sort((a, b) => a.value?.localeCompare(b.value))
          .map((institution: ItemVM) => (
            <MenuItem key={institution.id} value={institution.id}>
              {institution.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListInstitution.displayName = 'List Institution component';

const MemoizedListInstitution = memo(ListInstitution);

export default MemoizedListInstitution as typeof ListInstitution;
